import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Accordion, Icon, Table, Loader} from 'semantic-ui-react';
import moment from 'moment';
import {Actions} from '../../../common/actions';
import {orderDateFormat} from '../../../common/constants/datesFormat';
import './orderDetail.scss';

class OrderDetail extends Component {
  constructor(props) {
    super(props);

    this.state = {
      'activeIndex': 0,
    };
  }

  componentDidMount() {
    const {selectedOrder} = this.props;
    this.props.loadOrderDetail(selectedOrder);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.selectedOrder !== this.props.selectedOrder) {
      this.props.loadOrderDetail(this.props.selectedOrder);
      this.setState({'activeIndex': 0});
    }
  }

  onSectionClick(value) {
    if (value === this.state.activeIndex) {
      this.setState({'activeIndex': null});
      return;
    }
    this.setState({'activeIndex': value});
  }

  render() {
    const {loading, invoiceList} = this.props;

    return (
      <div className='invoice-list'>
        {loading && <Loader active inline='centered' />}
        {!loading && (
          <Accordion fluid>{this.renderInvoiceList(invoiceList)}</Accordion>
        )}
      </div>
    );
  }

  renderInvoiceList(list) {
    const {activeIndex} = this.state;

    return list.map((element, index) => {
      return (
        <Accordion key={index}>
          <Accordion.Title
            index={index}
            active={activeIndex === index}
            onClick={this.onSectionClick.bind(this, index)}
          >
            <div className='section-header'>
              <h4 className='invoice'>Factura {element.invoice}</h4>
              <h4 className='total-days'>{element.totalDays} Días</h4>
              <Icon name='dropdown' />
            </div>
          </Accordion.Title>
          <Accordion.Content active={activeIndex === index}>
            <Table striped>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    <Icon
                      name={element.orderDate ? 'selected radio' : 'radio'}
                    />{' '}
                    Pedido Realizado
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDateAndUser(
                      element.orderDate,
                      element.orderSubmitter
                    )}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <Icon
                      name={element.invoiceDate ? 'selected radio' : 'radio'}
                    />{' '}
                    Recepción de Factura
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDateAndUser(
                      element.invoiceDate,
                      element.invoiceReceiver
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDaysPeriod(
                      element.invoiceDate,
                      element.orderDate
                    )}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <Icon
                      name={element.paymentDate ? 'selected radio' : 'radio'}
                    />{' '}
                    Liquidación de Pedido
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDateAndUser(
                      element.paymentDate,
                      element.paymentResponsible
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDaysPeriod(
                      element.paymentDate,
                      element.orderDate
                    )}
                  </Table.Cell>
                </Table.Row>
                <Table.Row>
                  <Table.Cell>
                    <Icon
                      name={element.binningDate ? 'selected radio' : 'radio'}
                    />{' '}
                    Paso a Stock
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDateAndUser(
                      element.binningDate,
                      element.binningResponsible
                    )}
                  </Table.Cell>
                  <Table.Cell>
                    {this.renderDaysPeriod(
                      element.binningDate,
                      element.orderDate
                    )}
                  </Table.Cell>
                </Table.Row>
              </Table.Body>
            </Table>
          </Accordion.Content>
        </Accordion>
      );
    });
  }

  renderDateAndUser(eventDate, eventUser) {
    if (eventDate) {
      return `${moment(eventDate).format(orderDateFormat)} por ${
        eventUser || 'desconocido'
      }`;
    }

    return null;
  }

  renderDaysPeriod(dateToCompare, orderDate) {
    if (dateToCompare) {
      return `${moment(dateToCompare)
        .diff(moment(orderDate), 'days', true)
        .toFixed(0)} Días`;
    }

    return null;
  }
}

const mapStateToProps = (state) => {
  return {
    'loading': state.order.loading,
    'invoiceList': state.order.invoiceList,
  };
};

const {loadOrderDetail} = Actions;

export default connect(mapStateToProps, {
  loadOrderDetail,
})(OrderDetail);
